<template>
  <section>
    <b-row>
      <b-col cols="12" xl="12" md="12">
        <b-form @submit.prevent>
          <b-card no-body class="invoice-preview-card modern-card">
            <b-card-body class="invoice-padding pt-0">
            <b-row class="invoice-spacing">
              <b-col cols="12" xl="6" class="mb-lg-1">
                <h6 class="mb-2 modern-label">{{ $t('Select Employee:') }}</h6>
                <v-select v-model="selectedMember" :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
                  :options="members.users" label="fullname" input-id="invoice-data-client" :clearable="false"
                  class="modern-select" />
                <div v-if="selectedMember" class="mt-2 employee-preview">
                 
                    <b-row>
                      <b-col cols="8" class="d-flex flex-column justify-content-center">
                        <h6 class="mb-1">
                          {{ selectedMember.fullname }}
                        </h6>
                        <b-card-text class="mb-0">
                          {{ $t('Registry No:') }} {{ selectedMember.membercode }}
                        </b-card-text>
                      </b-col>

                      <b-col cols="4" class="text-center d-flex flex-column align-items-center justify-content-between">
                        <b-avatar :src="selectedMember.photo" :text="avatarText(selectedMember.fullname)" size="80px"
                          rounded class="mb-2" />

                      </b-col>
                    </b-row>
                    <b-button block variant="primary" class="modern-btn mt-auto" @click="addToList(selectedMember)">
                      {{ $t('Add to Training') }}
                    </b-button>
                 
                </div>
              </b-col>
            </b-row>
            </b-card-body>
          </b-card>
        </b-form>
      </b-col>
    </b-row>
    <hr class="modern-divider">
    <b-row class="invoice-add">
      <b-col cols="12" xl="12" md="12">
        <!-- Table Container Card -->
        <b-card no-body class="modern-table-card">
          <!-- table -->
          <b-card :title="$t('Assigned Employees')">
            <!-- input search -->
            <div class="custom-search d-flex justify-content-end">
              <b-form-group>
                <div class="d-flex align-items-center justify-content-end">
                  <label class="mr-1">{{ $t('Search') }}</label>
                  <b-form-input v-model="searchTerm" :placeholder="$t('Search')" type="text"
                    class="d-inline-block mr-1 modern-search" />
                </div>
              </b-form-group>
            </div>
            <vue-good-table :columns="columns" :rows="rows" :sort-options="{
              enabled: true,
              initialSortBy: { field: 'id', type: 'desc' }
            }" :line-numbers="true" :search-options="{
              enabled: true,
              externalQuery: searchTerm
            }" :pagination-options="{
              enabled: true,
              perPage: pageLength
            }">
              <template slot="table-row" slot-scope="props">
                <!-- Column: Name -->
                <div v-if="props.column.field === 'firstName'" class="text-nowrap">
                  <b-avatar :src="props.row.photo" class="mx-1" />
                  <span class="text-nowrap">{{ props.row.firstName }}</span>
                </div>

                <!-- Column: Status -->
                <span v-else-if="props.column.field === 'status'">
                  <b-badge :variant="statusVariant(props.row.status)">
                    {{ props.row.status }}
                  </b-badge>
                </span>

                <!-- Column: Action -->
                <span v-else-if="props.column.field === 'action'">
                  <span>
                    <div class="align-content-center">
                      <feather-icon @click="removeMember(props.row.id)" :id="`invoice-row-${props.row.id}-send-icon`"
                        icon="TrashIcon" class="cursor-pointer action-icon" size="16" />
                      <b-tooltip :title="$t('Remove Employee')" class="cursor-pointer"
                        :target="`invoice-row-${props.row.id}-send-icon`" />
                    </div>
                  </span>
                </span>
                <span v-else>
                  {{ props.formattedRow[props.column.field] }}
                </span>
              </template>
              <!-- pagination -->
              <template slot="pagination-bottom" slot-scope="props">
                <div class="d-flex justify-content-between flex-wrap">
                  <div class="d-flex align-items-center mb-0 mt-1">
                    <span class="text-nowrap">
                      {{ $t('Showing 1 to') }}
                    </span>
                    <b-form-select v-model="pageLength" :options="['3', '5', '10']" class="mx-1"
                      @input="(value) => props.perPageChanged({ currentPerPage: value })" />
                    <span class="text-nowrap "> {{ $t('of') }} {{ props.total }} {{ $t('entries') }} </span>
                  </div>
                  <div>
                    <b-pagination :value="1" :total-rows="props.total" :per-page="pageLength" first-number last-number
                      align="right" prev-class="prev-item" next-class="next-item" class="mt-1 mb-0"
                      @input="(value) => props.pageChanged({ currentPage: value })">
                      <template #prev-text>
                        <feather-icon icon="ChevronLeftIcon" size="18" />
                      </template>
                      <template #next-text>
                        <feather-icon icon="ChevronRightIcon" size="18" />
                      </template>
                    </b-pagination>
                  </div>
                </div>
              </template>
            </vue-good-table>
          </b-card>
        </b-card>
      </b-col>
    </b-row>
  </section>
</template>

<script>
import Logo from '@core/layouts/components/Logo.vue'
import { VueGoodTable } from 'vue-good-table'
import { ref, onUnmounted, onMounted, watch, inject } from '@vue/composition-api'
import { heightTransition } from '@core/mixins/ui/transition'
import Ripple from 'vue-ripple-directive'
import store from '@/store'

import {
  BCardBody, BFormInvalidFeedback, BTab, BTabs, BForm, VBToggle, VBModal, BCard, BRow, BCol, BFormInput, BButton, BTable, BMedia, BAvatar, BLink,
  BBadge, BDropdown, BDropdownItem, BPagination, BFormGroup, BFormSelect, BSidebar,BCardText
} from 'bootstrap-vue'
import vSelect from 'vue-select'
import flatPickr from 'vue-flatpickr-component'

import orientationStoreModule from '@/views/hr/orientation/orientationStoreModule'
import { avatarText } from '@core/utils/filter'
import ToastificationContent from '@core/components/toastification/ToastificationContent'
import { useToast } from 'vue-toastification/composition'
import Swal from 'sweetalert2'

export default {
  components: {
    flatPickr,
    BCardBody, BFormInvalidFeedback, BTab, BTabs, BForm, VBToggle, VBModal, BCard, BRow, BCol, BFormInput, BButton, BTable, BMedia, BAvatar, BLink,
    BBadge, BDropdown, BDropdownItem, BPagination, BFormGroup, BFormSelect, BSidebar,BCardText,
    vSelect,
    Logo,
    VueGoodTable
  },
  data() {
    return {
      pageLength: 10,
      dir: false,
      columns: [
        {
          label: 'Id',
          field: 'id',
          type: 'number',
          hidden: true,
          filterOptions: {
            enabled: true,
            placeholder: 'Search Id',
          },
        },
        {
          label: this.$t('Name'),
          field: 'firstName',
          filterOptions: {
            enabled: true,
            placeholder: 'Search Name',
          },
        },
        {
          label: this.$t('Surname'),
          field: 'lastName',
          filterOptions: {
            enabled: true,
            placeholder: 'Search Surname',
          },
        },
        {
          label: this.$t('Registry No'),
          field: 'memberCode',
          filterOptions: {
            enabled: true,
            placeholder: 'Search Registry',
          },
        },
        {
          label: this.$t('Mobile'),
          field: 'mobile',
          filterOptions: {
            enabled: true,
            placeholder: 'Search Mobile',
          },
        },
        {
          label: this.$t('Action'),
          field: 'action',
          tdClass: 'text-center'
        },
      ],
      searchTerm: '',
    }
  },
  directives: {
    Ripple,
    'b-toggle': VBToggle,
  },
  mixins: [heightTransition],
  props: {
    trainingId: {
      type: Number,
      required: true,
    }
  },
  setup(props) {
    const toast = useToast()
    const TRAINING_APP_STORE_MODULE = 'hr-training'

    // Register module
    if (!store.hasModule(TRAINING_APP_STORE_MODULE)) store.registerModule(TRAINING_APP_STORE_MODULE, orientationStoreModule)

    // UnRegister on leave
    onUnmounted(() => {
      if (store.hasModule(TRAINING_APP_STORE_MODULE)) store.unregisterModule(TRAINING_APP_STORE_MODULE)
    })

    const members = ref([])
    const rows = ref([])

    const fetchMembers = () => {
      store.dispatch('fetchMembers')
        .then(response => {
          members.value = response.data
        })
        .catch(error => {
          if (error.response.status === 404) {
            members.value = undefined
          }
        })
    }
    const fetchMembersByTrainingId = () => {
      store.dispatch('fetchAssignedMembersToTraining', { id: props.trainingId })
        .then(response => {
          toast({
            component: ToastificationContent,
            props: {
              title: 'Success fetched employees.',
              icon: 'BellIcon',
              variant: 'success',
            },
          })
          rows.value = response.data
        })
        .catch(error => {
          rows.value = []
          toast({
            component: ToastificationContent,
            props: {
              title: 'Error could not fetch employees for this training.',
              icon: 'AlertTriangleIcon',
              variant: 'danger',
            },
          })
          if (error.response.status === 404) {
            rows.value = []
          }
        })
    }
    const removeMember = (id) => {
      Swal.fire({
        title: 'Are you sure?',
        text: 'You won\'t be able to revert this!',
        icon: 'warning',
        showCancelButton: true,
        confirmButtonText: 'Yes, delete it!',
        customClass: {
          confirmButton: 'btn btn-primary',
          cancelButton: 'btn btn-outline-danger ml-1',
        },
        buttonsStyling: false,
      })
        .then(result => {
          if (result.value) {
            store.dispatch('deleteAssignedMembersFromTraining', { id })
              .then(response => {
                Swal.fire({
                  icon: 'success',
                  title: 'Deleted!',
                  timer: 2000,
                  text: 'Employee has been removed.',
                })
                fetchMembersByTrainingId()
              })
              .catch(error => {
                Swal.fire({
                  icon: 'error',
                  title: 'Failed!',
                  text: 'Employee could not been removed from training.',
                  customClass: {
                    confirmButton: 'btn btn-danger',
                  },
                })
              })
          }
        })
    }
    onMounted(() => {
      fetchMembers()
      fetchMembersByTrainingId()
    })

    const selectedMember = ref(null)

    const addToList = (client) => {
      let clientDto = {
        trainingId: props.trainingId,
        firstName: client.firstname,
        lastName: client.lastname,
        photo: client.photo,
        memberCode: client.membercode,
        userGuid: client.userguid,
        additionalInfo: client.additionalinfo,
        mobile: client.mobile
      }
      store.dispatch('assignMembersToTraining', clientDto)
        .then(response => {
          toast({
            component: ToastificationContent,
            props: {
              title: 'Success added employee to training.',
              icon: 'BellIcon',
              variant: 'success',
            },
          })
          fetchMembersByTrainingId()
          selectedMember.value = null
        })
        .catch(error => {
          toast({
            component: ToastificationContent,
            props: {
              title: 'Error could not assigned employee to training.',
              icon: 'AlertTriangleIcon',
              variant: 'danger',
            },
          })
        })
    }

    return {
      rows,
      members,
      addToList,
      selectedMember,
      avatarText,
      fetchMembersByTrainingId,
      fetchMembers,
      removeMember,
    }
  },
}
</script>

<style lang="scss">
@import '@core/scss/vue/libs/vue-select.scss';
@import '@core/scss/vue/libs/vue-flatpicker.scss';
@import '@core/scss/vue/libs/vue-good-table.scss';

// Sadece modern CSS eklemeleri
.modern-card {
  border-radius: 12px !important;
  box-shadow: 0 4px 6px rgba(0, 0, 0, 0.07) !important;
}

.modern-table-card {
  border-radius: 12px !important;
  box-shadow: 0 4px 6px rgba(0, 0, 0, 0.07) !important;
}

.modern-label {
  font-weight: 600 !important;
  color: #374151 !important;
}

.modern-select .vs__dropdown-toggle {
  border: 1.5px solid #d1d5db !important;
  border-radius: 8px !important;
}

.employee-preview {
  background: #f9fafb !important;
  border: 1px solid #e5e7eb !important;
  border-radius: 12px !important;
  padding: 20px !important;
  text-align: start;
}



.modern-btn {
  border-radius: 10px !important;
  font-weight: 900 !important;
}

.modern-divider {
  border: none !important;
  height: 1px !important;
  background: #e5e7eb !important;
  margin: 2rem 0 !important;
}

.modern-search {
  border: 1.5px solid #d1d5db !important;
  border-radius: 8px !important;
}

.action-icon:hover {
  color: #dc2626 !important;
  background: #fee2e2 !important;
  border-radius: 4px !important;
  padding: 2px !important;
}

.invoice-add-wrapper {
  .add-new-client-header {
    padding: $options-padding-y $options-padding-x;
    color: $success;

    &:hover {
      background-color: rgba($success, 0.12);
    }
  }
}
</style>

<style lang="scss" scoped>
@import "~@core/scss/base/pages/app-invoice.scss";
@import '~@core/scss/base/components/variables-dark';

.form-item-section {
  background-color: $product-details-bg;
}

.form-item-action-col {
  width: 27px;
}

.repeater-form {
  transition: .35s height;
}

.v-select {

  &.item-selector-title,
  &.payment-selector {
    background-color: #fff;

    .dark-layout & {
      background-color: unset;
    }
  }
}

.dark-layout {
  .form-item-section {
    background-color: $theme-dark-body-bg;

    .row .border {
      background-color: $theme-dark-card-bg;
    }
  }
}
</style>